<template>
  <div class="view-about-content">
    <p class="view-about-lead">Some things in my own life are easier to see through someone else’s questions.</p>
    <p v-if="!condensed">This archive brings together work, ideas and experiences from different moments in my life. Looking back, I sometimes notice details I had overlooked or understand them differently.</p>
    <p v-if="!condensed">Your questions can connect these pieces in ways I would not have thought of. I’m curious about what you notice and how it might change my own understanding.</p>
    <p class="view-about-signature" role="img" aria-label="Henry"><svg viewBox="0 0 79 44" fill="currentColor" fill-rule="evenodd" aria-hidden="true" focusable="false"><path v-for="(path,index) in signaturePaths" :key="index" :d="path"/></svg></p>
    <template v-if="!condensed">
      <GalleryProjectLink v-if="article" class="view-about-design-entry" @project="$emit('project',$event)"/>
      <GalleryDesignLink v-else class="view-about-design-entry" @design="$emit('design')"/>
    </template>
  </div>
</template>
<script>
import GalleryDesignLink from './GalleryDesignLink.vue';
import GalleryProjectLink from './GalleryProjectLink.vue';
import identity from '../../assets/identity/identity-motion.json';
export default {
  components:{GalleryDesignLink,GalleryProjectLink},props:{condensed:Boolean,article:Boolean},emits:['design','project'],
  data:()=>({signaturePaths:[identity.initials[0],identity.suffixes[0]]}),
};
</script>
<style scoped>
.view-about-content {color:var(--ex-ink,var(--site-text-primary,#34372f));}
.view-about-content p {margin:0 0 21px;font:16px/1.7 'Quattrocento Sans',sans-serif;text-wrap:pretty;}
.view-about-content .view-about-lead {font:25px/1.35 'EB Garamond',serif;margin-bottom:25px;}
.view-about-content .view-about-signature {font:27px 'La Belle Aurore',cursive;margin:24px 0 30px;}
.view-about-signature svg{display:block;height:1.4em;width:auto;overflow:visible;}
.view-about-design-entry{padding-top:12px}
@media(max-width:767px){.view-about-content p{font-size:15px;line-height:1.6;margin-bottom:17px}.view-about-content .view-about-lead{font-size:23px}}
</style>
